<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.daySmeltingProductQuality") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/prd/daySmeltingProductQuality"><span>{{$t('tlt.daySmeltingProductQuality')}}</span></router-link></li>
                </ul>
            </div>
            <!-- <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('daySmeltingProductQuality')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>                       
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div> -->
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.locName") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="plantFilter"/>
                                </div> 
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.startDay") }} :
                                    </label>
                                    <mmf-datepicker      v-model="startDayFilter"></mmf-datepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.endDay") }} :
                                    </label>
                                    <mmf-datepicker      v-model="endDayFilter"></mmf-datepicker>
                                </div>                               
                                <div class="col-lg-6 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('daySmeltingProductQuality')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('daySmeltingProductQuality')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="daySmeltingProductQualityResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="daySmeltingProductQuality" inline-actions-disabled singleChoice>
                             <div slot="btnList" class="btn-group" slot-scope="slotProps" :singleChoice='true'>                                   
                                    <button
                                        :disabled="slotProps.checkedLength!=1"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        v-on:click="getReport(entity)">
                                        <i class="fa fa-tasks" aria-hidden="true"></i>  
                                        <span class="text">{{$t('btn.dayReport')}}</span>                                         
                                    </button>                 
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
           
        </section>        
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/prd/productionReport/dayReport/DaySmeltingProductQuality";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from '@/components/MmfDatepicker';


// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'daySmeltingProductQuality/getField',
    mutationType: 'daySmeltingProductQuality/updateField',
});

export default {
  name: "daySmeltingProductQualityList",
  data () {
    return {
   
    }
  },
  components: { MmfTable, MmfDatepicker },
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.daySmeltingProductQuality.rows,            
            checkedItems: state => state.daySmeltingProductQuality.checkedItems,
             entity: state => state.daySmeltingProductQuality.entity,
            tableColumns: gridFields
        }),
    
  },
  methods: {
...mapActions("base", [ "MMFNew", "MMFLoadRows", "MMFClearFilter"]),
     ...mapActions("daySmeltingProductQuality", ["getReport"])
  },
   
};
</script>
